import { Box } from '@mui/material';
import { colors } from '@src/styles';
import { monoFontFamily } from '../utils/format';

const MAP: Record<string, { label: string; color: string }> = {
  SUCCEEDED: { label: 'Sucesso', color: colors.status.concluded },
  FAILED: { label: 'Falha', color: colors.status.rejected },
  RUNNING: { label: 'Em execução', color: colors.status.pending },
};

export function StatusChip({ status }: { status: string }) {
  const s = MAP[status] ?? { label: status || 'RUNNING', color: colors.brand.textSecondary };
  return (
    <Box
      component="span"
      title={status}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        height: 22,
        px: 1,
        borderRadius: '999px',
        fontFamily: monoFontFamily,
        fontSize: '10px',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        color: s.color,
        backgroundColor: `${s.color}14`,
        border: `1px solid ${s.color}55`,
      }}
    >
      <Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: s.color }} />
      {s.label}
    </Box>
  );
}
